import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "subGrid mtop-03" }
const _hoisted_3 = { style: {"grid-column":"left"} }
const _hoisted_4 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_5 = { style: {"grid-column":"left"} }
const _hoisted_6 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_7 = { style: {"grid-column":"left"} }
const _hoisted_8 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_9 = { class: "row-top gap-10" }
const _hoisted_10 = {
  key: 0,
  class: "bg-blue-04 pad-l rnd-m"
}
const _hoisted_11 = {
  key: 0,
  style: {"width":"8.9rem"}
}
const _hoisted_12 = { class: "mtop-04" }
const _hoisted_13 = { class: "subGrid mtop-04" }
const _hoisted_14 = { style: {"grid-column":"left"} }
const _hoisted_15 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_16 = { style: {"grid-column":"left"} }
const _hoisted_17 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_18 = { style: {"grid-column":"left"} }
const _hoisted_19 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_20 = { class: "row-top mtop-10 gap-15" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = {
  class: "bg-blue-04 pad-l rnd-m",
  style: {"display":"flex","flex-direction":"column","place-content":"space-between"}
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "row mtop-10 gap-20" }
const _hoisted_25 = { class: "row" }

import luPidContest from './luPidContest.vue';
import loadingSpinner from "@/views/loadingSpinner.vue";

import { ref, computed, PropType } from 'vue';
import { useI18n} from "vue-i18n";
import { apiDateString, apiAmountCurrency} from '@/api/apicommon';
import SessionStorageService from '@/services/SessionStorageService';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useToast } from 'primevue';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import cnsEconnectorApi, { CnsOperationType } from '@/api/cnsEconnectorApi';
import { pidSimulationTimeout} from '@/api/cnsEconnectorApi';
import officeapi from '@/api/officeapi';
import { isBefore, addMinutes } from 'date-fns';
import patientapi from '@/api/patientapi';
import { CNSApi, FinancialChannelLightResponse, InvoiceResponse, PostCreateCnsLogRequest, PostRaSendMhRequest } from '@/apiGenerate/medserver';
import {extractErrorsFromCnsAnomalie} from '@/api/cnsEconnectorApi';
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'luPid',
  props: {
  invoice: {
    type: Object as PropType<InvoiceResponse>,
    required: true,
  },
  financialChannel: {
    type: Object as PropType<FinancialChannelLightResponse>,
    required: true,
  },
  financialGroupId: {
    type: Number,
    required: true,
  },
  isPidTargetChannel: {
    type: Boolean,
    required: true,
  },
  mockMode: {
    type: String,
    required: true,
  },
  eConnectorApiError: {
    type: Boolean,
    required: true,
  },
  eConnectorActivated: {
    type: Boolean,
    required: true,
  },
  simulationAnomalies: {
    type: Array,
    required: false,
  },
  eConnectorAwaiting: {
    type: Boolean,
    required: false,
  },  
},
  emits: ['reload', 'redoPidSimulation'],
  setup(__props, { emit: __emit }) {

const toast = useToast();
const {t} = useI18n();
const cnsApi = new CNSApi(medServerApiConfig);
const MockMode = {
  OFF: 'off',
  ECONNECTOR_DISABLED: 'mockEconnectorDisabled',
  ECONNECTOR_NO_PORT: 'mockEconnectorNoPort',
  ECONNECTOR_ERROR: 'mockEconnectorError',
  PID_REFUSED: 'mockPidRefused',
  PID_OK: 'mockPidOk',
} as const;

const props = __props

const emits = __emit

const eConnectorAwaiting = ref(false);
const isLoading = computed(() => props.eConnectorAwaiting);

const luBillEtransferData = computed(() => props.invoice.patientDocument?.luBillEtransferData);
const currInvoice = ref(props.invoice)

const personName = computed(() => {
  const pwr = currInvoice.value.pwrCounterParty;
  return PersonService.formatName(pwr.lastName, pwr.firstName);
})

function hasNonExpiredSimulation(invoice: InvoiceResponse): boolean {
  const pidSimulationTimestamp = invoice?.patientDocument?.luBillEtransferData?.pidSimulationTimestamp;
  if (!pidSimulationTimestamp) return false;
  const expirationDate = addMinutes(new Date(pidSimulationTimestamp), pidSimulationTimeout);
  const now = new Date();
  return isBefore(now, expirationDate);
}

// eConnector calls
async function callEconnectorContestation(invoiceId: number, cnsAuthorizationUuid: string): Promise<{ success: boolean, errorDetails?: string }> {
  // MOCK
  if (props.mockMode !== MockMode.OFF) {
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (props.mockMode === MockMode.ECONNECTOR_ERROR) {
      return { success: false, errorDetails: '- Mock: Contestation failed' };
    }
    return { success: true };
  }

  // REAL
  const port = SessionStorageService.getItem('cnsEconnectorApiPort');
  const contestationPidRequest = await cnsApi.postPIDSimulationContestation({simulationId: cnsAuthorizationUuid, pidSimulationContestationRequest: { simulationId: cnsAuthorizationUuid, invoiceId: invoiceId }});
  const cnsResponse = await cnsEconnectorApi.contestSimulation(port, contestationPidRequest.gpCode, contestationPidRequest.xmlRequest);

  const errorsMap = extractErrorsFromCnsAnomalie(cnsResponse.anomalies);
  let errorDetails = '';
  errorsMap.forEach((value) => {
    errorDetails += '- ' + value + '\n';
  });

  const cnsLogRequest: PostCreateCnsLogRequest = {
    cnsLogRequest: {
      operationType: CnsOperationType.PID_CONTEST_SIMULATION.toString(),
      requestContent: contestationPidRequest.xmlRequest,
      responseContent: JSON.stringify(cnsResponse),
      status: errorDetails !== '' ? 'NOK' : 'OK',
      timestamp: new Date(),
      financialGroupId: props.financialGroupId
    }
  };
  await cnsApi.postCreateCnsLog(cnsLogRequest);

  return { success: errorDetails === '', errorDetails: errorDetails || undefined };
}

async function callEconnectorValidation(invoiceId: number, cnsAuthorizationUuid: string): Promise<{ success: boolean, errorDetails?: string }> {
  // MOCK
  if (props.mockMode !== MockMode.OFF) {
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (props.mockMode === MockMode.ECONNECTOR_ERROR) {
      return { success: false, errorDetails: '- Mock: Validation failed' };
    }
    return { success: true };
  }

  // REAL
  const port = SessionStorageService.getItem('cnsEconnectorApiPort');
  const validationPidRequest = await cnsApi.postPIDSimulationValidation({simulationId: cnsAuthorizationUuid, pidSimulationValidationRequest: { simulationId: cnsAuthorizationUuid, invoiceId: invoiceId }});
  const cnsResponse = await cnsEconnectorApi.validateSimulation(port, validationPidRequest.gpCode, validationPidRequest.xmlRequest);

  const errorsMap = extractErrorsFromCnsAnomalie(cnsResponse.anomalies);
  let errorDetails = '';
  errorsMap.forEach((value) => {
    errorDetails += '- ' + value + '\n';
  });

  const cnsLogRequest: PostCreateCnsLogRequest = {
    cnsLogRequest: {
      operationType: CnsOperationType.PID_VALIDATE_SIMULATION.toString(),
      requestContent: validationPidRequest.xmlRequest,
      responseContent: JSON.stringify(cnsResponse),
      status: errorDetails !== '' ? 'NOK' : 'OK',
      timestamp: new Date(),
      financialGroupId: props.financialGroupId
    }
  };
  await cnsApi.postCreateCnsLog(cnsLogRequest);

  return { success: errorDetails === '', errorDetails: errorDetails || undefined };
}

async function callEconnectorRa(invoiceId: number): Promise<{ success: boolean, errorDetails?: string }> {
  // MOCK
  if (props.mockMode !== MockMode.OFF) {
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (props.mockMode === MockMode.ECONNECTOR_ERROR) {
      return { success: false, errorDetails: '- Mock: MH send failed' };
    }
    return { success: true };
  }

  // REAL
  const port = SessionStorageService.getItem('cnsEconnectorApiPort');
  const raSendMhRequest: PostRaSendMhRequest = { raSendMhRequest: { invoiceId: invoiceId } };
  const raSendMhResponse = await cnsApi.postRaSendMh(raSendMhRequest);
  const cnsResponse = await cnsEconnectorApi.sendMh(port, raSendMhResponse.gpCode, raSendMhResponse.xmlRequest);

  const errorsMap = extractErrorsFromCnsAnomalie(cnsResponse.anomalies);
  let errorDetails = '';
  errorsMap.forEach((value) => {
    errorDetails += '- ' + value + '\n';
  });

  const cnsLogRequest: PostCreateCnsLogRequest = {
    cnsLogRequest: {
      operationType: CnsOperationType.RA_SEND_MH.toString(),
      requestContent: raSendMhResponse.xmlRequest,
      responseContent: JSON.stringify(cnsResponse),
      status: errorDetails !== '' ? 'NOK' : 'OK',
      timestamp: new Date(),
      financialGroupId: props.financialGroupId
    }
  };
  await cnsApi.postCreateCnsLog(cnsLogRequest);

  return { success: errorDetails === '', errorDetails: errorDetails || undefined };
}

async function contestPid(invoice: InvoiceResponse){
  if (!props.eConnectorActivated) return;
  if (props.eConnectorApiError) return;
  if (invoice.invoiceStatus !== "Precomplete") return;
  if (!hasCns.value) return;
  const luBillEtransferData = props.invoice.patientDocument?.luBillEtransferData;
  if (luBillEtransferData?.pidValidationTimestamp) return;
  if (luBillEtransferData?.raValidationTimestamp) return;
  if (luBillEtransferData?.raCancellationTimestamp) return;
  if (!hasNonExpiredSimulation(invoice)) {
    toastError(toast, {
      summary: t('accounting.econnector.pidSimulation.toast.expiredSummary'),
      detail: t('accounting.econnector.pidSimulation.toast.expiredDetail'),
      life: 5000
    });
    return;
  }

  const invoiceId = invoice.id;

  if (eConnectorAwaiting.value) return;
  eConnectorAwaiting.value = true;

  try {
    const eConnectorResult = await callEconnectorContestation(invoiceId, luBillEtransferData.cnsAuthorizationUuid);

    if (!eConnectorResult.success) {
      toastError(toast, {
        summary: t('accounting.econnector.pidContestation.toast.error'),
        detail: eConnectorResult.errorDetails
          ? t('accounting.econnector.pidContestation.toast.errorWithDetails', { details: '\n' + eConnectorResult.errorDetails })
          : t('accounting.econnector.pidContestation.toast.error'),
      });
      return;
    }
    toastSuccess(toast, {
        summary: t('accounting.econnector.pidContestation.toast.success'),
        life: 5000
    });
    //Backend
    const pidContestationTimestamp = new Date();  //Todo: replace with timeStamp form eConnector response
    const newluBillEtransferData = await patientapi.addPidContestationToEtransferData(invoiceId.toString(), pidContestationTimestamp)
    luBillEtransferData.value = newluBillEtransferData
    emits('reload');  // ← Added
  } catch (error) {
    toastError(toast, {
        summary: t('accounting.econnector.pidContestation.toast.error'),
        detail: t('accounting.econnector.service.unspecifiedError'),
        life: 5000
    });
  } finally {
      eConnectorAwaiting.value = false;
  }
}

function redoPidSimulation() {
  emits('redoPidSimulation');
}
const isDirectPaymentChannel = computed(() => ["Cash", "BankCard", "DigitalPayment"].includes(props.financialChannel.type));
const hasCns = computed(() => props.invoice.pwrCounterParty.hasCns);

async function validatePid(invoice: InvoiceResponse, targetFinancialChannel: FinancialChannelLightResponse){
  if (!props.eConnectorActivated) return;
  if (props.eConnectorApiError) return;
  if (props.invoice.simulationError) return;
  if (invoice.invoiceStatus !== "Precomplete") return;
  if (!hasCns.value) return;
  const eTransferData = luBillEtransferData.value;
  if (eTransferData?.pidValidationTimestamp) return;
  if (eTransferData?.raValidationTimestamp) return;
  if (eTransferData?.raCancellationTimestamp) return;
  if (targetFinancialChannel.type === "Cancelled") return;
  if (!hasNonExpiredSimulation(invoice)) {
    toastError(toast, {
        summary: t('accounting.econnector.pidSimulation.toast.expiredSummary'),
        detail: t('accounting.econnector.pidSimulation.toast.expiredDetail'),
        life: 5000
      });
    return;
  }
  const invoiceId = invoice.id;
  const targetFinancialChannelId = targetFinancialChannel.id;
  const paymentDate = new Date();
  if (eConnectorAwaiting.value) return;
  eConnectorAwaiting.value = true;
  try {
    const eConnectorResult = await callEconnectorValidation(invoiceId, eTransferData.cnsAuthorizationUuid);
    if (!eConnectorResult.success) {
      toastError(toast, {
        summary: t('accounting.econnector.pidValidation.toast.error'),
        detail: eConnectorResult.errorDetails
          ? t('accounting.econnector.pidValidation.toast.errorWithDetails', { details: '\n' + eConnectorResult.errorDetails })
          : t('accounting.econnector.pidValidation.toast.error'),
      });
      return;
    }
    toastSuccess(toast, {
        summary: t('accounting.econnector.pidValidation.toast.success'),
        life: 5000
    });
    //Backend finalization
    await officeapi.finalizeInvoiceToPid(targetFinancialChannelId.toString(), invoiceId.toString(), paymentDate.toISOString());
    const pidValidationTimestamp = new Date();  //Todo: replace with timeStamp form eConnector response
    const newluBillEtransferData = await patientapi.addPidValidationToEtransferData(invoiceId.toString(), pidValidationTimestamp) 
    luBillEtransferData.value = newluBillEtransferData    
    emits('reload');
  } catch (error) {
    toastError(toast, {
        summary: t('accounting.econnector.pidValidation.toast.error'),
        detail: t('accounting.econnector.service.unspecifiedError'),
        life: 5000
    });
  } finally {
    eConnectorAwaiting.value = false;
  }
}

const canPerformImmediateEConnectorRa = computed(() => {
  return hasCns.value && props.eConnectorActivated && !props.eConnectorApiError;
})

const willBeMarkedAsPaidForCns = computed(() => {
  //If a bill is marked as paid for the CNS, the transaction will be locked
  return hasCns.value && props.eConnectorActivated && isDirectPaymentChannel.value;
})

async function finalizeInvoiceRa(invoice: InvoiceResponse, targetFinancialChannel: FinancialChannelLightResponse) {
  if (invoice.invoiceStatus !== "Precomplete") return;
  const eTransferData = luBillEtransferData.value;
  if (eTransferData?.pidValidationTimestamp) return;
  if (eTransferData?.raValidationTimestamp) return;
  if (eTransferData?.raCancellationTimestamp) return;
  if (targetFinancialChannel.type === "Cancelled") return;

  const targetFinancialChanneType = targetFinancialChannel.type;
  const invoiceId = invoice.id;
  const transactionDate = new Date().toISOString();
  const total = invoice.amount;
  if (eConnectorAwaiting.value) return;
  eConnectorAwaiting.value = true;
  try {
    // Step 1: Backend finalization (always done, even if eConnector fails later)
    if (!willBeMarkedAsPaidForCns.value) {
      await officeapi.finalizeInvoiceToUnpaid(invoiceId.toString());
    }
    if (targetFinancialChanneType !== 'RemainingBalance') {                  //finalized to paid 100% + Transaction OR only transaction
      await officeapi.addTransaction(null, targetFinancialChannel.id.toString(), invoiceId.toString(), transactionDate, total);
    }

    // Step 2: eConnector (best-effort)
    if (canPerformImmediateEConnectorRa.value) {
      const eConnectorResult = await callEconnectorRa(invoiceId);

      if (eConnectorResult.success) {
        const raValidationTimestamp = new Date();
        const newluBillEtransferData = await patientapi.addRaValidationToEtransferData(
          invoice.id.toString(),
          raValidationTimestamp
        );
        luBillEtransferData.value = newluBillEtransferData;

        toastSuccess(toast, {
          summary: t('accounting.econnector.sendMh.toast.success'),
          life: 5000
        });
      } else {
        toastError(toast, {
          summary: t('accounting.econnector.sendMh.toast.error'),
          detail: eConnectorResult.errorDetails
            ? t('accounting.econnector.sendMh.toast.errorWithDetails', { details: '\n' + eConnectorResult.errorDetails })
            : t('accounting.econnector.sendMh.toast.error'),
          life: 5000
        });
      }
    }
  } catch (error) {
    toastError(toast, {
      summary: t('accounting.econnector.sendMh.toast.error'),
      detail: t('accounting.econnector.service.unspecifiedError'),
      life: 5000
    });
  } finally {
    eConnectorAwaiting.value = false;
    // Always reload since backend succeeded
    emits('reload');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_button_group = _resolveComponent("button-group")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal col gap-06",
    style: {"width":"fit-content"},
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_text_item, {
          txt: personName.value,
          styles: "font-l"
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('accounting.econnector.cancelMh.invoiceNumber'),
            styles: "main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_text_item, {
            txt: __props.invoice.invoiceReference,
            class: "mleft-auto",
            styles: "main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('accounting.econnector.cancelMh.invoiceDate'),
            styles: "main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_text_item, {
            txt: _unref(apiDateString)(__props.invoice.invoiceDateTime),
            class: "mleft-auto",
            styles: "main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('accounting.econnector.cancelMh.total'),
            styles: "main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_text_item, {
            txt: _unref(apiAmountCurrency)(__props.invoice.amount, __props.invoice.currencyIso),
            class: "mleft-auto",
            styles: "main-m"
          }, null, 8, ["txt"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (props.eConnectorActivated && props.isPidTargetChannel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('accounting.econnector.pid.title'),
                styles: "font-mBold"
              }, null, 8, ["txt"])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(loadingSpinner, {
                    logo: false,
                    style: 'w-3',
                    class: "mtop-10"
                  })
                ]))
              : (props.eConnectorApiError || !luBillEtransferData.value?.pidSimulationTimestamp)
                ? (_openBlock(), _createBlock(_component_text_item, {
                    key: 1,
                    txt: _unref(t)('accounting.econnector.pid.unavailable'),
                    styles: "font-m",
                    class: "text-error"
                  }, null, 8, ["txt"]))
                : (props.invoice.simulationError && !luBillEtransferData.value?.pidContestationTimestamp)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('accounting.econnector.pid.simulationRefused'),
                          styles: "font-m",
                          class: "text-error"
                        }, null, 8, ["txt"])
                      ]),
                      _createVNode(_unref(Accordion), {
                        value: "0",
                        class: "mtop-04",
                        style: {"width":"30em"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(AccordionPanel), { value: "1" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(AccordionHeader), null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_text_item, {
                                    txt: _unref(t)('accounting.econnector.pid.contest'),
                                    styles: "font-m",
                                    class: "main-h"
                                  }, null, 8, ["txt"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(AccordionContent), null, {
                                default: _withCtx(() => [
                                  _createVNode(luPidContest, {
                                    invoice: props.invoice,
                                    eConnectorAwaiting: eConnectorAwaiting.value,
                                    simulationAnomalies: props.simulationAnomalies,
                                    onContestPid: _cache[0] || (_cache[0] = ($event: any) => (contestPid(currInvoice.value)))
                                  }, null, 8, ["invoice", "eConnectorAwaiting", "simulationAnomalies"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (luBillEtransferData.value.cnsPartAmount)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('accounting.econnector.pid.cnsPart'),
                              styles: "main-m"
                            }, null, 8, ["txt"])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_text_item, {
                              txt: _unref(apiAmountCurrency)(luBillEtransferData.value.cnsPartAmount, __props.invoice.currencyIso),
                              styles: "main-m",
                              class: "mleft-auto"
                            }, null, 8, ["txt"])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('accounting.econnector.pid.patientPart'),
                              styles: "main-m"
                            }, null, 8, ["txt"])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_text_item, {
                              txt: _unref(apiAmountCurrency)(luBillEtransferData.value.paidByPatientAmount, __props.invoice.currencyIso),
                              styles: "main-m",
                              class: "mleft-auto"
                            }, null, 8, ["txt"])
                          ]),
                          (luBillEtransferData.value.pidContestationTimestamp)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_text_item, {
                                    txt: _unref(t)('accounting.econnector.pid.contestedOn'),
                                    styles: "main-m",
                                    class: "text-error"
                                  }, null, 8, ["txt"])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_text_item, {
                                    txt: _unref(apiDateString)(luBillEtransferData.value.pidContestationTimestamp),
                                    styles: "main-m",
                                    class: "mleft-auto text-error"
                                  }, null, 8, ["txt"])
                                ])
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          (luBillEtransferData.value.pidContestationTimestamp)
                            ? (_openBlock(), _createBlock(_component_button_group, {
                                key: 0,
                                disabled: eConnectorAwaiting.value,
                                styles: "border-h pad-s",
                                class: "psides-06",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (redoPidSimulation()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_text_item, {
                                    txt: _unref(t)('accounting.econnector.pid.redoSimulation'),
                                    styles: "font-mBold"
                                  }, null, 8, ["txt"])
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                            : (_openBlock(), _createBlock(_component_button_group, {
                                key: 1,
                                styles: "border-h pad-s",
                                disabled: eConnectorAwaiting.value,
                                class: "psides-06",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (validatePid(currInvoice.value, __props.financialChannel)))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_text_item, {
                                      txt: _unref(t)('accounting.econnector.pid.confirm'),
                                      styles: "font-mBold"
                                    }, null, 8, ["txt"]),
                                    _createElementVNode("div", _hoisted_21, [
                                      _createVNode(_component_text_item, {
                                        txt: __props.financialChannel.title,
                                        styles: "font-m"
                                      }, null, 8, ["txt"]),
                                      _createVNode(_component_text_item, {
                                        txt: _unref(apiAmountCurrency)(luBillEtransferData.value.paidByPatientAmount, __props.invoice.currencyIso),
                                        styles: "font-m main-h",
                                        class: "mleft-04"
                                      }, null, 8, ["txt"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_22, [
        (__props.eConnectorActivated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              (!hasCns.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('accounting.econnector.ra.withoutEConnector'),
                      styles: "font-mBold"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('accounting.invoice.notCns'),
                      styles: "font-m"
                    }, null, 8, ["txt"])
                  ], 64))
                : (props.eConnectorApiError)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('accounting.econnector.ra.title'),
                        styles: "font-mBold"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('accounting.econnector.ra.directTransmissionImpossible'),
                        styles: "font-m",
                        class: "text-error"
                      }, null, 8, ["txt"])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('accounting.econnector.ra.title'),
                        styles: "font-mBold"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: willBeMarkedAsPaidForCns.value ? _unref(t)('accounting.econnector.ra.paidForCns') : _unref(t)('accounting.econnector.ra.notPaidForCns'),
                        styles: "font-m main-m"
                      }, null, 8, ["txt"])
                    ], 64))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_button_group, {
            styles: "border-h pad-s",
            disabled: eConnectorAwaiting.value,
            class: "psides-06",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (finalizeInvoiceRa(currInvoice.value, __props.financialChannel)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('accounting.econnector.ra.confirm'),
                  styles: "font-mBold"
                }, null, 8, ["txt"]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_text_item, {
                    txt: __props.financialChannel.title,
                    styles: "font-m"
                  }, null, 8, ["txt"]),
                  _createVNode(_component_text_item, {
                    txt: _unref(apiAmountCurrency)(__props.invoice.amount, __props.invoice.currencyIso),
                    styles: "main-h",
                    class: "mleft-04"
                  }, null, 8, ["txt"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})